module.exports = __webpack_public_path__ + "img/greenRupee.a20f0707.svg";